import { format } from "date-fns";

const HAS_TIMEZONE = /(Z|[+-]\d{2}:?\d{2})$/;

export const formatCardDate = (date: string | undefined): string => {
  if (!date) {
    return "";
  }
  try {
    return format(new Date(HAS_TIMEZONE.test(date) ? date : `${date}Z`), "MMM dd, yyyy");
  } catch {
    return "";
  }
};
